module.exports = __webpack_public_path__ + "static/media/3.94506a5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3.jpg
// module id = 90
// module chunks = 0